import React from 'react';
import ErrorWindow from '../ErrorWindow/ErrorWindow';
const GeneralError = () => <div data-trk-error-page data-sentry-component="GeneralError" data-sentry-source-file="GeneralError.tsx">
    <ErrorWindow data-sentry-element="ErrorWindow" data-sentry-source-file="GeneralError.tsx">
      {'Vi gör allt för att lösa problemet så snabbt som möjligt. Testa att ladda om eller gå vidare till'}
      <a href={'/'}>Startsidan.</a>
    </ErrorWindow>
  </div>;
export default GeneralError;